import { executeCorrectiveActions, GetSFMDisplay } from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";

/**
 * ExceptionsRecordActions Component
 * Encapsulates action definitions for the exceptions record table
 */
export const ExceptionsRecordActions = ({ translate, store }) => {
  return {
    FORCE_CLEAR: {
      actionTypeTag: "FORCE_CLEAR",
      name: translate("exceptions-record.actions.forceClear"),
      actionFN: (
        row,
        ids,
        selectedReason,
        reasonDescription,
        sourceAmount,
        destinationAmount
      ) => {
        executeCorrectiveActions({
          ActionTypeTag: "FORCE_CLEAR",
          ExceptionRecords: row?.id ? [row.id] : ids.split(","),
          ActionReasonTag: selectedReason,
          ActionReasonDescription: reasonDescription,
          AdjustedSourceAmount: sourceAmount,
          AdjustedDestinationAmount: destinationAmount,
          callback: (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData);
          },
          store: store,
        });
      },
      severity: "high",
      confirmation: true,
      confirmationMessage: translate(
        "exceptions-record.confirmation.forceClear"
      ),
      showReason: true,
      hasAmounts: true,
      largerPopup: true,
    },
    UNDO_EXCEPTION: {
      actionTypeTag: "UNDO_EXCEPTION",
      name: translate("exceptions-record.actions.undoException"),
      actionFN: (row, ids, selectedReason, reasonDescription) => {
        executeCorrectiveActions({
          ActionTypeTag: "UNDO_EXCEPTION",
          ExceptionRecords: row?.id ? [row.id] : ids.split(","),
          ActionReasonTag: selectedReason,
          ActionReasonDescription: reasonDescription,
          callback: (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData);
          },
          store: store,
        });
      },
      confirmation: true,
      confirmationMessage: translate(
        "exceptions-record.confirmation.undoException"
      ),
      severity: "high",
      showReason: true,
    },
    ATTEMPT_MATCHING: {
      actionTypeTag: "ATTEMPT_MATCHING",
      name: translate("exceptions-record.actions.attemptMatching"),
      actionFN: (row, ids, selectedReason, reasonDescription) => {
        window.location.href = `/exception-attempt-matching?id=${row.original.MatchingRecordId}`;
      },
    },
  };
};

/**
 * Global Actions for mass operations
 */
export const ExceptionsRecordGlobalActions = ({ translate, store }) => {
  return {
    FORCE_CLEAR: {
      actionTypeTag: "FORCE_CLEAR",
      name: translate("shared.globalActions.forceClear"),
      actionFN: (row, ids, selectedReason, reasonDescription) => {
        executeCorrectiveActions({
          ActionTypeTag: "FORCE_CLEAR",
          ExceptionRecords: row?.id ? [row.id] : ids.split(","),
          ActionReasonTag: selectedReason,
          ActionReasonDescription: reasonDescription,
          callback: (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.reload();
            });
          },
          store: store,
        });
      },
      severity: "high",
      confirmation: true,
      confirmationMessage: translate(
        "shared.globalActions.confirmation.forceClear"
      ),
      showReason: true,
    },
    UNDO_EXCEPTION: {
      actionTypeTag: "UNDO_EXCEPTION",
      name: translate("shared.globalActions.undoException"),
      actionFN: (row, ids, selectedReason, reasonDescription) => {
        executeCorrectiveActions({
          ActionTypeTag: "UNDO_EXCEPTION",
          ExceptionRecords: row?.id ? [row.id] : ids.split(","),
          ActionReasonTag: selectedReason,
          ActionReasonDescription: reasonDescription,
          callback: (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.reload();
            });
          },
          store: store,
        });
      },
      severity: "high",
      confirmation: true,
      confirmationMessage: translate(
        "shared.globalActions.confirmation.undoException"
      ),
      showReason: true,
    },
  };
};
